import { defineComponent } from 'vue';
import BaseModal from '@/components/Shared/Modals/BaseModal/BaseModalComponent';
import { mapWritableState } from 'pinia';
import { useRegisterTestStore } from '@/store/RegisterTestStore';
import ThemesHelper from '@/helpers/ThemesHelper';
import positionWrongImage from '@/assets/themes/chembio/position-wrong.png';
import positionCorrectImage from '@/assets/themes/chembio/correct-position.png';

export default defineComponent({
  components: {
    BaseModal,
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ['patient']),
  },
  data() {
    return {
      StepContent: ThemesHelper.getThemeParams('testStepThreeContents'),
      positionCorrectImage: positionCorrectImage,
      positionWrongImage: positionWrongImage,
    };
  },
  methods: {
    toggleModal(status: boolean) {
      const el: any = this.$refs['base-modal'];
      el.toggleBaseModal(status);
    },
    goBack() {
      this.toggleModal(false);
    },
  },
});
